import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';
import { getMenuItems, sideMenuAdditionalItemsWithIcons } from './consts';
import LayoutBase from '../LayoutBase';
import { menuItems as settingsMenuItems } from '../SettingsLayout/consts';
import { useSideMenuItems } from '../hooks';
import { SideMenuItem } from '../../molecules/SideMenu/types';
import useUserContext from '../../../hooks/useUserContext';
import { useDashboardStats } from '../../../pages/dashboard/hooks';
import routes from '../../../setup/consts/routes';

const MainLayout: React.FC = ({ children }) => {
  const { user } = useUserContext();
  const intl = useIntl();

  const { data: dashStats } = useDashboardStats({});
  const failedCount = dashStats?.response?.failedOrders ?? 0;

  const rawItems = useMemo(
    () =>
      getMenuItems({
        isAdvancedUser: Boolean(user?.isAdvancedUser),
        isSandoogUser: Boolean(user?.isSandoogUser),
      }).map((item) =>
        item.to === routes.FAILED_ORDERS && failedCount > 0
          ? { ...item, badge: failedCount }
          : item
      ),
    [user, failedCount]
  );

  const items = useSideMenuItems(rawItems as unknown as SideMenuItem[]);

  const menuAdditionalItems = useMemo(
    () => sideMenuAdditionalItemsWithIcons(intl),
    [intl]
  );
  const settingsItems = useSideMenuItems(
    settingsMenuItems as unknown as SideMenuItem[]
  );

  return (
    <LayoutBase
      {...{ items, settingsItems }}
      additionalItems={menuAdditionalItems}
    >
      {children}
    </LayoutBase>
  );
};

export default MainLayout;
